import { gate } from 'hub-http/gates';
export const PRE_APPROVED = 'Payments:Pay040PreApprovedEnrollment';
export const KYC_EMBEDDED_FALLBACK_EXPERIENCE = gate('Payments:StripeEmbeddedOnboardingFallback');
export const COMMERCE_HOME_PRE_TOOL_START = gate('TACQ:CommerceHomePreToolStart');
export const PRODUCT_BUILDER = gate('commerce:product:product-builder');